import React from "react";
import ReactDOM from "react-dom/client";
import _ from "lodash";

class AmrRace extends React.Component {
  /**
   * Creates an instance of GestiawebUpdates.
   * @param {Object} props - Propriétés
   */
  constructor(props) {
    super(props);
    this.state = {
      id: props.id,
      amrRace: {},
      amrChampionshipCategories: [],
      currentHeats: [],
      currentScores: [],
      search: {
        heat: "",
        category: ""
      }
    };
  }

  /**
   * Fonction spécifique à ReactJS pour charger le composant
   */
  componentDidMount() {
    fetch(`/amr-race/_api/index/${this.state.id}`)
      .then(res => res.json())
      .then(result => {
        var formattedAmrChampionshipCategories = result.findedAmrChampionshipCategories.reduce((newArray, amrChampionshipCategory) => {
            newArray.push({
              name: amrChampionshipCategory.name,
              id: amrChampionshipCategory.id,
              value: amrChampionshipCategory.id,
              sub: false
            });
            if (amrChampionshipCategory.amr_sub_championship_categories.length) {
              amrChampionshipCategory.amr_sub_championship_categories.map(subAmrChampionshipCategory => {
                newArray.push({
                  name: `${amrChampionshipCategory.name} > ${subAmrChampionshipCategory.name}`,
                  id: subAmrChampionshipCategory.id,
                  value: `${subAmrChampionshipCategory.amrChampionshipCategoryId}-${subAmrChampionshipCategory.id}`,
                  sub: true
                });
              });
            }
            return newArray;
          }, []),
          currentCategory = formattedAmrChampionshipCategories[0],
          currentHeats,
          currentScores;

        currentHeats = result.findedAmrRace.amr_heats.filter(amrHeat => {
          let amrChampionshipCategoryId = currentCategory.sub ? parseInt(currentCategory.value.split("-")[0], 10) : parseInt(currentCategory.value, 10),
            amrSubChampionshipCategoryId = currentCategory.sub ? parseInt(currentCategory.value.split("-")[1], 10) : null;
          return amrHeat.amrChampionshipCategoryId === amrChampionshipCategoryId && amrHeat.amrSubChampionshipCategoryId === amrSubChampionshipCategoryId;
        });

        currentScores = this.sortScores(currentHeats[0].amr_scores);

        this.setState({
          amrRace: result.findedAmrRace,
          amrChampionshipCategories: formattedAmrChampionshipCategories,
          currentHeats,
          currentScores
        });
      });
  }

  /**
   * Permet de changer de catégorie
   * @param {Event} e - Evénement associé au change du select de la catégorie
   */
  changeCategory(e) {
    var amrChampionshipCategoryId = parseInt(e.target.value.split("-")[0], 10),
      amrSubChampionshipCategoryId = parseInt(e.target.value.split("-")[1], 10) || null,
      currentHeats = this.state.amrRace.amr_heats.filter(amrHeat => {
        return amrHeat.amrChampionshipCategoryId === amrChampionshipCategoryId && amrHeat.amrSubChampionshipCategoryId === amrSubChampionshipCategoryId;
      });

    this.setState({
      currentHeats,
      currentScores: this.sortScores(currentHeats[0].amr_scores)
    });
  }

  /**
   * Permet de changer de manche
   * @param {Event} e - Evénement associé au change du select de la manche
   */
  changeHeat(e) {
    var currentScores = this.state.currentHeats.find(amrHeat => {
      return amrHeat.id === parseInt(e.target.value, 10);
    }).amr_scores;

    this.setState({
      currentScores: this.sortScores(currentScores)
    });
  }

  /**
   * Permet de mettre à jour la position lors du on change
   * @param {object} score - Score à éditer
   * @param {object} e - Evénement associé au change du champ
   */
  updatePosition(score, e) {
    var currentScores = this.state.currentScores.map(amrScore => {
      if (score.id === amrScore.id) {
        amrScore.position = parseInt(e.target.value, 10);
      }
      return amrScore;
    });
    this.setState({
      currentScores
    });
  }

  /**
   * Permet de sauvgarder la nouvelle position dans la base de donnée
   * @param {object} score - Score à sauvegarder
   * @param {Event} e - Evénement associé au blur du champ
   */
  savePosition(score, e) {
    var view = this,
      newPosition = parseInt(e.target.value, 10);

    if (newPosition) {
      fetch("/amr-race/_api/update", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          position: newPosition,
          amrScoreId: score.id
        })
      })
        .then(res => res.json())
        .then(result => {
          var currentScores = view.state.currentScores.map(amrScore => {
            if (score.id === amrScore.id && newPosition) {
              amrScore.point = result.point;
              amrScore.standard_point = result.standard_point;
              amrScore.state = result.state;
            }
            return amrScore;
          });

          view.setState({
            currentScores: view.sortScores(currentScores)
          });

          e.target.value = "";
        });
    }
  }

  /**
   * Permet de trier les scores par position
   * @param {Array<Object>} amrScores - Liste des scores
   */
  sortScores(amrScores) {
    return _.sortBy(amrScores, "position");
  }

  /**
   * Rendu du composant
   * @return {Object} Le noeud HTML à afficher dans la page
   */
  render() {
    return (
      <div className="grid--layout" style={{ gridTemplateColumns: "100%", gridTemplateRows: "auto 1fr" }}>
        <div>
          <div className="search">
            <div className="search__title">Votre recherche</div>
            <div className="search__fields">
              <select className="input-group__input input-group--no-margin" onChange={this.changeCategory.bind(this)}>
                {this.state.amrChampionshipCategories.map((amrChampionshipCategory, index) => (
                  <option value={amrChampionshipCategory.value} key={amrChampionshipCategory.value}>
                    {amrChampionshipCategory.name}
                  </option>
                ))}
              </select>
              <select className="input-group__input input-group--no-margin" onChange={this.changeHeat.bind(this)}>
                {this.state.currentHeats.map(amrHeat => (
                  <option value={amrHeat.id} key={amrHeat.id}>
                    {amrHeat.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div>
          <div className="grid grid--has-5-child">
            {this.state.currentScores.map((amrScore, index) => (
              <div className={amrScore.state ? "card card--success" : "card"} key={index}>
                <header className="card__header">
                  <h4 className="card__header-title">N° {amrScore.amr_race_registration.number}</h4>
                </header>
                <main className="card__description card__description--no-height">
                  <p className="card__description__paragraph">
                    <div className="badge">Position : {amrScore.position}</div>
                  </p>
                  <p className="card__description__paragraph">
                    <div className="badge">Points calculés : {amrScore.point}</div>
                  </p>
                  <p className="card__description__paragraph">
                    <div className="badge">Points standards : {amrScore.standard_point}</div>
                  </p>
                  <div className="card__description__line">
                    <div className="input-group input-group--no-margin">
                      <input className="input-group__input" type="number" onChange={this.updatePosition.bind(this, amrScore)} onBlur={this.savePosition.bind(this, amrScore)} placeholder="Renseignez la position du pilote" />
                    </div>
                  </div>
                </main>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

var amrRaceNode = document.getElementById("amr-race");
if (amrRaceNode) {
  var root = ReactDOM.createRoot(amrRaceNode);
  root.render(<AmrRace id={amrRaceNode.getAttribute("data-id")} />);
}
